// ---------------------------------------------------------------------------
// ConcurrencyCard — the "Concurrency" section card. Two inputs:
// Workers (free-text, 'auto' / blank → omitted) and Parallelism (dropdown).
// Determines how trials are scheduled across the worker pool at run time.
// ---------------------------------------------------------------------------

import { Dropdown, Field, Input, Option } from '@fluentui/react-components';

import { useStyles } from '../../EvaluationTemplateForm.style.js';
import {
  PARALLELISM_OPTIONS,
  type ParallelismChoice,
} from '../../EvaluationTemplateForm.types.js';

export interface ConcurrencyCardProps {
  workersText: string;
  onWorkersChange: (s: string) => void;
  parallelism: ParallelismChoice;
  onParallelismChange: (p: ParallelismChoice) => void;
}

export function ConcurrencyCard({
  workersText,
  onWorkersChange,
  parallelism,
  onParallelismChange,
}: ConcurrencyCardProps) {
  const styles = useStyles();
  return (
    <section className={styles.card} aria-labelledby="card-concurrency">
      <div id="card-concurrency" className={styles.cardLabel}>
        Concurrency
      </div>
      <div className={styles.cardBody}>
        <div className={styles.twoColumnFields}>
          <Field
            label="Workers"
            hint="Worker pool size — defaults to number of available processors"
          >
            <Input
              value={workersText}
              onChange={(_e, data) => onWorkersChange(data.value)}
            />
          </Field>
          <Field
            label="Parallelism"
            hint="How trials are scheduled across workers"
          >
            <Dropdown
              value={
                PARALLELISM_OPTIONS.find((o) => o.value === parallelism)
                  ?.label ?? parallelism
              }
              selectedOptions={[parallelism]}
              onOptionSelect={(_e, data) => {
                if (data.optionValue) {
                  onParallelismChange(data.optionValue as ParallelismChoice);
                }
              }}
              aria-label="Parallelism"
            >
              {PARALLELISM_OPTIONS.map((o) => (
                <Option key={o.value} value={o.value} text={o.label}>
                  {o.label}
                </Option>
              ))}
            </Dropdown>
          </Field>
        </div>
      </div>
    </section>
  );
}
